module.exports = __webpack_public_path__ + "static/img/theory_post.7e6720c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/question/theory_post.jpg
// module id = oRHI
// module chunks = 1